module.exports = __webpack_public_path__ + "assets/img/scan-code@2x.bbe531f4.png";